var ko = require('knockout'),
  APIHelper = require('_js/APIHelper'),
  PAGE_TYPE = require('_js/constants/registration-page-type'),
  SIGNUP_TYPE = require('_js/constants/signup-type'),
  partition = require('lodash/partition');

var NOT_CONNECTED_TO_BUREAU = 2;

function RegistrationConfirmation(params) {
  var self = this;

  if (params.step === undefined) {
    throw 'No steps parameter passed to this component!';
  }

  self.parent = params.parent;

  self.step = params.step;
  self.API = params.api;
  self.currentStep = ko.observable(self.parent.currentStep());
  self.SIGNUP_TYPE = SIGNUP_TYPE;
  self.noActorId = ko.observable(false);

  self.isSubmitting = ko.observable(false);

  // Determine if this page is the current step.
  self.parent.currentStep.subscribe(function(val) {
    if (val === self.step()) {
      self.activateComponent();
    }
  });

  self.invoiceAgencyName = ko.observable();
  self.agencies = ko.observableArray();
  self.bureauConnections = ko.observableArray();
  self.newAgency = ko.observableArray([]);

  self.registrationConfirmation = ko.observable().extend({
    required: [
      {
        type: 'isCheckedOff',
        message: self.parent.errorMessages.requiredBoxUnchecked
      }
    ]
  });

  self.showInvoiceSection = ko.observable(false);
  self.showInsuranceSection = ko.observable(false);
  self.showInsuranceBought = ko.observable(false);
  self.showInsuranceExternal = ko.observable(false);
  self.showTermsAndConditions = ko.observable(false);

  self.invoiceOptions = ko.observable().extend({
    required: [
      {
        type: 'isNotEmpty',
        message: self.parent.errorMessages.noAlternativeChosen
      }
    ]
  });
  self.invoiceEmail = ko.observable().extend({
    required: [
      { type: 'isOptional', message: 'Optional' },
      { type: 'isEmail', message: self.parent.errorMessages.invalidEmail }
    ]
  });

  self.requiredFields = [self.registrationConfirmation];

  self.showInvoiceSection.subscribe(function(newVal) {
    if (newVal) {
      self.requiredFields = [
        self.registrationConfirmation,
        self.invoiceOptions
      ];
    } else {
      self.requiredFields = [self.registrationConfirmation];
    }
  });

  this.allData = ko.observable();
  // We need to call this function now incase we reload on this step (which will not trigger
  // the currentStep.subscribe function).
  self.activateComponent();
  var regData = sessionStorage.getItem('rn-registration');
  if (regData !== undefined && regData !== null) {
    var parsedRegData = JSON.parse(regData);
    parsedRegData.signupType = self.parent.signuptype;
    this.allData(parsedRegData);
  }
}

RegistrationConfirmation.prototype.checkedBureauConnections = function(index) {
  // Need to offset the index because the invoice list has one more agency before the list of already
  // connected agencies.
  var matchingIndex = index + 1;
  if (
    parseInt(this.bureauConnections()[index](), 10) ===
      NOT_CONNECTED_TO_BUREAU &&
    matchingIndex === parseInt(this.invoiceOptions(), 10)
  ) {
    this.invoiceOptions(undefined);
  }

  // Need to return true in order to get checked + click binding to work.
  return true;
};

RegistrationConfirmation.prototype.activateComponent = function() {
  var self = this;
  // Since this is called in the constructor we need to do verify that we are at the correct step.
  if (self.step() === self.parent.currentStep()) {
    // If the user has gone through the process of registering himself/herself.
    if (self.parent.signuptype === 'studentandpractice') {
      self.showInvoiceSection(false);
    } else if (self.parent.signuptype === 'person') {
      self.showInvoiceSection(true);
    } else if (self.parent.signuptype === 'agency') {
      self.showInvoiceSection(true);
    }

    var regData = sessionStorage.getItem('rn-registration');
    if (regData !== undefined && regData !== null) {
      var parsedRegData = JSON.parse(regData);
      self.allData(parsedRegData);
      if (parsedRegData.personalInfo) {
        self.personalInfo = parsedRegData.personalInfo;
      }
      if (parsedRegData.infoEmployer) {
        self.infoEmployer = parsedRegData.infoEmployer;
      }
      if (parsedRegData.infoAgency) {
        self.infoAgency = parsedRegData.infoAgency;
      }
      if (parsedRegData.enroll) {
        self.enroll = parsedRegData.enroll;
      }
      if (parsedRegData.insurance) {
        self.insurance = parsedRegData.insurance;
      }

      // Determine if we have the 'AktorId' property for the user.
      if (
        !(self.personalInfo && self.personalInfo.person) &&
        !(self.enroll && self.enroll.person)
      ) {
        self.noActorId(true);
      }

      // Depending on the signuptype / the data we have, extract the agency/employer name.
      if (self.infoEmployer && self.infoEmployer.employer) {
        self.invoiceAgencyName(self.infoEmployer.employer.Name);
      } else if (self.infoAgency && self.infoAgency.agency) {
        self.invoiceAgencyName(self.infoAgency.agency.Name);
      }
    }

    // If the user has the insurance step we need to show the summary of it.
    if (self.parent.steps().indexOf(PAGE_TYPE.INSURANCE) !== -1) {
      self.showInsuranceSection(true);
      if (self.insurance && self.insurance.externalInsuranceId) {
        // Show text for external insurance
        self.showInsuranceExternal(true);
        self.showInsuranceBought(false);
      } else {
        self.showInsuranceBought(true);
        self.showInsuranceExternal(false);
      }
    }

    self.setAgencies();
  }
};

RegistrationConfirmation.prototype.setAgencies = function() {
  var self = this,
    url = self.API.getAgenciesForPerson;

  if (self.noActorId()) {
    return;
  }
  if (self.personalInfo && self.personalInfo.person) {
    url += '?AktorId=' + self.personalInfo.person.AktorId;
  } else if (self.enroll && self.enroll.person) {
    url += '?AktorId=' + self.enroll.person.AktorId;
  }

  APIHelper.get(
    url,
    function(data) {
      var modifiedAgencies = self.checkExistingAgencies(data);
      self.agencies(modifiedAgencies);
      // Prefill the radio buttons to answer "yes" (/ "1").
      var tmp = [];
      for (var i = 0; i < self.agencies().length; i++) {
        tmp.push(ko.observable('1'));
      }
      self.bureauConnections(tmp);
    },
    function(response) {
      var location = window.location.href || document.URL;
      APIHelper.post('/api/log/error', {
        message: 'API-error: registration-confirmation.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + response.responseText,
          'status: ' + response.status,
          'statusText: ' + response.statusText,
          'requestUrl: ' + url
        ]
      });
    }
  );
};

RegistrationConfirmation.prototype.checkExistingAgencies = function(agencies) {
  var modifiedAgencies = agencies;
  // This is perhaps no longer needed. Letting it stay for a couple of iterations before removing it completely.
  var agencyPartitions;

  if (this.infoEmployer && this.infoEmployer.employer) {
    agencyPartitions = partition(agencies, {
      AktorId: this.infoEmployer.employer.AktorId
    });
    modifiedAgencies = agencyPartitions[1];
    this.newAgency(agencyPartitions[0]);
    if (this.newAgency() === undefined || this.newAgency() === null) {
      this.newAgency(this.infoEmployer.employer);
    }
  } else if (this.infoAgency && this.infoAgency.agency) {
    agencyPartitions = partition(agencies, {
      AktorId: this.infoAgency.agency.AktorId
    });
    modifiedAgencies = agencyPartitions[1];
    this.newAgency(agencyPartitions[0]);
    if (agencyPartitions[0].length === 0) {
      this.newAgency().push(this.infoAgency.agency);
    }
  }
  return modifiedAgencies;
};

RegistrationConfirmation.prototype.populateInputFromStore = function() {};

RegistrationConfirmation.prototype.getAllIndexes = function(arr, val) {
  var indexes = [],
    i;
  for (i = 0; i < arr.length; i++) {
    if (arr[i]() === val) {
      indexes.push(i);
    }
  }
  return indexes;
};

RegistrationConfirmation.prototype.createStoreObject = function() {
  // Get all the indexes where the user doesn't want to be connected to the agency.
  var removedAgencyConnectionsIndices = this.getAllIndexes(
    this.bureauConnections(),
    '2'
  );
  // This will be the list containing the IDs of the agencies the user wants to remove.
  var removedAgencyConnections = [];

  var newAgency = false;
  var paySelf = false;
  var agencyId = '';

  for (var i = 0; i < removedAgencyConnectionsIndices.length; i++) {
    removedAgencyConnections.push(
      this.agencies()[removedAgencyConnectionsIndices[i]].Id
    );
  }

  if (this.invoiceOptions() === 'new') {
    newAgency = true;
  } else if (this.invoiceOptions() === 'self') {
    paySelf = true;
  } else if (this.invoiceOptions() !== undefined) {
    if (parseInt(this.invoiceOptions(), 10) === this.agencies().length) {
      newAgency = true;
    } else {
      agencyId = this.agencies()[parseInt(this.invoiceOptions(), 10) - 1]
        .AktorId;
    }
  }

  // Store all the observable values into an object.
  return {
    removeAssociatedAgencies: removedAgencyConnections,
    agencyId: agencyId,
    NewAgency: newAgency,
    PaySelf: paySelf,
    invoiceEmail: this.invoiceEmail()
  };
};

RegistrationConfirmation.prototype.storeValues = function() {
  // 1: Get the registration data.
  var regData = sessionStorage.getItem('rn-registration');

  if (regData === undefined || regData === null) {
    regData = {};
  } else {
    regData = JSON.parse(regData);
  }

  // 2: Update the correct page in the registration data with the submitted data.
  regData.infoSummary = this.createStoreObject();

  // 3: Update lastUpdated date.
  regData.lastUpdated = new Date().getTime();

  // 4: Set current path.
  regData.registrationPath = this.parent.currentPath;

  // 5: Store the update.
  sessionStorage.setItem('rn-registration', JSON.stringify(regData));
};

RegistrationConfirmation.prototype.validateInputOnStep = function() {
  return this.parent.validateFields(this.requiredFields);
};

RegistrationConfirmation.prototype.previousStep = function() {
  this.parent.previousStep();
};

RegistrationConfirmation.prototype.toggleTermsAndConditions = function() {
  this.showTermsAndConditions(!this.showTermsAndConditions());
};

RegistrationConfirmation.prototype.submitData = function() {
  var self = this,
    url = self.API.postSignupSummary;

  var regData = sessionStorage.getItem('rn-registration');
  if (regData !== undefined && regData !== null) {
    var parsedRegData = JSON.parse(regData);
    parsedRegData.signupType = self.parent.signuptype;
    this.allData(parsedRegData);
  }

  self.isSubmitting(true);

  APIHelper.post(
    url,
    this.allData(),
    function(data) {
      self.isSubmitting(false);
      sessionStorage.removeItem('rn-registration');
      self.parent.storeValuesForStep('result', data);
      self.parent.nextStep();
    },
    function(err) {
      self.isSubmitting(false);
      self.parent.storeValuesForStep('result', null);
      self.parent.nextStep();
      var location = window.location.href || document.URL;
      APIHelper.post('/api/log/error', {
        message: 'API-error: registration-confirmation.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + err.responseText,
          'status: ' + err.status,
          'statusText: ' + err.statusText,
          'requestUrl: ' + url
        ]
      });
    }
  );
};

RegistrationConfirmation.prototype.nextStep = function() {
  // 1: Validate step. If successful, goto next step.
  if (!this.validateInputOnStep()) {
    var location = window.location.href || document.URL;
    APIHelper.post('/api/log/error', {
      message: 'NOT-VALIDATED: registration-confirmation.js',
      context: location,
      parameters: [
        'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
        'platform: ' + navigator.platform
      ]
    });
    return;
  }

  // 2: Store values inputted by the user into Storage.
  this.storeValues();

  // 3: Allow to continue execution.

  this.submitData();
};

module.exports = RegistrationConfirmation;
